import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { IFilmOrderListItem } from '../Entities';
import { Table } from 'react-bootstrap';
import FilmOrderListRow from './FilmOrderListRow';

interface IFilmOrderListProps {
    orders: IFilmOrderListItem[];
    user: any;
}

const FilmOrderList = (props: IFilmOrderListProps) => {
    return (
        <Table className="order-table table-nopadding" hover responsive data-testid="order-table">
            <thead>
                <tr>
                    <th>{Translate('orders/list/film/header/order-number')}</th>
                    <th>{Translate('orders/list/film/header/broker-firm')}</th>
                    <th>{Translate('orders/list/film/header/product')}</th>
                    <th>{Translate('orders/list/film/header/address')}</th>
                    <th>{Translate('orders/list/film/header/city')}</th>
                    <th>{Translate('orders/list/film/header/photographer')}</th>
                    <th>{Translate('orders/list/film/header/deadline')}</th>
                    <th>{Translate('orders/list/film/header/status')}</th>
                    <th>{Translate('orders/list/film/header/order-locked-by')}</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.orders &&
                    props.orders.map((i: IFilmOrderListItem) => (
                        <FilmOrderListRow order={i} key={i.orderId} user={props.user} />
                    ))}
            </tbody>
        </Table>
    );
};

export default FilmOrderList;
